module.exports = __webpack_public_path__ + "static/media/weed-control.661b1ef2.jpg";